<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" class="edit-picker-box">
    <el-dialog title="" :visible="true" :before-close="closeBox">
      <el-form :model="form" label-width="120px">
        <el-form-item label="买手组:">
          <el-input
            v-model="form.pg_name"
            style="width: 50%"
            :disabled="!!form.pg_id"
            placeholder="买手组"
          ></el-input>
        </el-form-item>
        <el-form-item label="组长:">
          <el-select
            v-model="form.group_leader"
            filterable
            style="width: 50%"
            placeholder="组长"
          >
            <el-option
              v-for="item in group_leader"
              :key="item.key"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="代号:">
          <el-input
            style="width: 50%"
            v-model="form.pg_code"
            placeholder="代号"
            :disabled="!!form.pg_id"
          ></el-input>
        </el-form-item>
        <el-form-item label="市场(地理位置)：">
          <el-select
            v-model="form.market_id"
            filterable
            clearable
            placeholder="市场"
            style="width: 50%"
            @change="onMainMarketChange"
          >
            <el-option
              v-for="item in market"
              :key="item.key"
              :label="item.label"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="子市场：">
          <el-select
            v-model="form.market_sub_id"
            filterable
            clearable
            placeholder="子市场"
            style="width: 50%"
          >
            <el-option
              v-for="item in subMarketList"
              :key="item.key"
              :label="item.label"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="attributable_market_id" label="业绩归属市场：">
          <el-select
            v-model="form.attributable_market_id"
            filterable
            clearable
            style="width: 50%"
            placeholder="业绩归属市场"
            @change="handleSetAttributableSubMarket($event, true)"
          >
            <el-option
              v-for="item in performanceMarketList"
              :key="item.attributable_market_id"
              :label="item.attributable_market_name"
              :value="item.attributable_market_id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="状态:">
          <el-select
            v-model="form.status"
            placeholder="状态"
            style="width: 50%"
          >
            <el-option value="" label="全部"></el-option>
            <el-option value="1" label="启用"></el-option>
            <el-option value="0" label="禁用"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button style="width: 25%" @click="closeBox">取消</el-button>
          <el-button type="success" style="width: 25%" @click="savesSubmitData">
            确认
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { removeFalsy } from "@/utils/utils.js";
import {
  getGetAttributableMarketList,
  postGetChildMarket,
} from "@/openapi/erp/supply.js";
import { getMarketList } from "@/controller/common2302.js";
import {
  postGetPickerGroupDetail,
  postUpdateOrAddPickerGroup,
} from "@/openapi/erp/pickerGroup.js";

export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
    group_leader: [],
  },
  data() {
    return {
      marketList: [], // 主市场列表
      subMarketList: [], // 子市场列表
      performanceMarketList: [], // 业绩归属市场列表
      form: {
        market_id: "",
        market_sub_id: "",
        group_leader: "",
      },
      market: [],
      fullscreenLoading: false,
    };
  },
  mounted() {
    this.fetchData();
    this.getMainMarketList();
    this.handleGetPerformanceMarketList();
  },
  methods: {
    // 设置业绩归属市场
    handleSetAttributableSubMarket(attributableMarketId, reset) {
      const selectedMainMarket = this.performanceMarketList.find(
        (option) => option.attributable_market_id === attributableMarketId
      );
      this.performanceSubMarketList = selectedMainMarket?.sub_list || [];
      if (
        reset ||
        !this.performanceSubMarketList.length ||
        this.form.attributable_market_sub_id.toString() === "0"
      ) {
        this.form.attributable_market_sub_id = "";
      }
    },
    // 获取业绩归属市场列表
    handleGetPerformanceMarketList() {
      getGetAttributableMarketList()
        .then((res) => {
          this.performanceMarketList = res;
        })
        .catch(this.$noop);
    },
    getMainMarketList() {
      getMarketList()
        .then((data) => {
          this.market = data;
        })
        .catch(this.$noop);
    },
    onMainMarketChange() {
      this.form.market_sub_id = "";
      this.getSubMarketList();
    },
    getSubMarketList() {
      postGetChildMarket({ parent_id: this.form.market_id }).then((res) => {
        this.subMarketList = res;
      });
    },
    fetchData() {
      if(!this.id) return
      postGetPickerGroupDetail({ pg_id: this.id }).then((res) => {
        this.form = res;
        this.getSubMarketList();
      });
    },
    submitData() {
      postUpdateOrAddPickerGroup(removeFalsy(this.form)).then(() => {
        this.$message.success("操作成功");
        this.closeBox();
      });
    },
    savesSubmitData() {
      if (this.form.status === "0") {
        this.$confirm("禁用买手组后，所绑定的商家会被自动释放", "提示", {
          closeOnClickModal: false,
          closeOnHashChange: false,
          showCancelButton: false,
        }).then(() => {
          this.submitData();
        });
      } else {
        this.submitData();
      }
    },

    closeBox() {
      this.$emit("onCloseDialog", false);
    },
  },
};
</script>

<style scoped>
.bottom-buttom {
  display: flex;
  flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/pages/picker/components/EditPicker.vue